import { render, staticRenderFns } from "./SocialMediaSpecialist.vue?vue&type=template&id=49bc7e79&scoped=true&"
import script from "./SocialMediaSpecialist.vue?vue&type=script&lang=js&"
export * from "./SocialMediaSpecialist.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaSpecialist.vue?vue&type=style&index=0&id=49bc7e79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bc7e79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49bc7e79')) {
      api.createRecord('49bc7e79', component.options)
    } else {
      api.reload('49bc7e79', component.options)
    }
    module.hot.accept("./SocialMediaSpecialist.vue?vue&type=template&id=49bc7e79&scoped=true&", function () {
      api.rerender('49bc7e79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/kariera/SocialMediaSpecialist.vue"
export default component.exports